import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import ConfirmationModal from '../../Popup/ConfirmationModal';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
const GroupJoinPendingModal = ({ group, popModal })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(ConfirmationModal, {
        onConfirm: popModal,
        onCancel: popModal,
        title: t('group.join.pending.popup.title'),
        text: /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: "group.join.pending.popup.body"
        }, "You’ll get notified if you’re accepted into ", {
            groupname: group.username
        }, ". To check the status of your request or withdraw it, go to the", /*#__PURE__*/ React.createElement(BiLink, {
            href: Url.feedbackLink()
        }), "tab in your notifications."))),
        withCancelButton: false,
        confirmBtnLabel: t('group.join.pending.popup.button.accept'),
        isOpen: true
    });
};
GroupJoinPendingModal.displayName = 'GroupJoinPendingModal';
export default GroupJoinPendingModal;

//# sourceMappingURL=GroupJoinPendingModal.js.map